import React from 'react';
import { UserMembersTranslation } from '../constants';
import { endpoints } from '../endpoints';
import {
  useClearAllEffect, useActionCreators, useDetailsCallbacks,
  useDetailsSelectors, useListSelectors
} from '../hooks';
import { UserMembersHeaderPicker } from './user-members-header-picker';
import { InfoText, ValidationMessage } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { routeConstants } from 'app/routes/route-constants';
import { getApplicationUrl } from 'app/infrastructure/hosting';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { mergeUrl } from 'app/area/subscriber-groups/user-members/utils/merge-url';
import styles from './user-members-header.scss';

interface UserMembersDetailsProps {
  id: number;
  shouldPrompt: boolean;
  activeValueError: ValidationMessage;
  translation: UserMembersTranslation;
}

export const UserMembersHeader: React.FC<UserMembersDetailsProps> = ({
  id, shouldPrompt, translation
}) => {

  useClearAllEffect(shouldPrompt);

  const { subscriberGroupValue, activeValue } = useDetailsSelectors();
  const { updateSubscriberGroup } = useDetailsCallbacks();
  const { loadListBranch, clearList } = useActionCreators();

  const { requestedModel } = useListSelectors();

  const onChange = (value: ComplexValue<number>) => {
    updateSubscriberGroup(value);

    if (!!value?.value) {
      const model = !!requestedModel
        ? {
          ...requestedModel,
          subscriberGroup: value.value
        }
        : { subscriberGroup: value.value, showAll: true };

      clearList(model);
      loadListBranch(model);
    }
  };

  const infoTextWithLink = replaceTemplateString(
    translation.info_text,
    mergeUrl(
      getApplicationUrl(),
      isDefinedIncludingZero(activeValue?.value)
        ? routeConstants.subscriberGroupsEditFor(activeValue.value)
        : routeConstants.subscriberGroupsList
    ) + `#[${translation.info_text_link}]`);

  return <>
    <div className="row">
      <div className="col-12 mb-3">
        <h1 className={styles.headerTitle}>
          {translation.user_members_title}
        </h1>
        {!!infoTextWithLink && <InfoText
          linkRouter={true}
          visible={true}
          text={infoTextWithLink} />}
      </div>
    </div>
    <div className="row">
      <UserMembersHeaderPicker
        componentId={'user-members-header-picker'}
        urlParamId={id}
        endpoint={endpoints.subscriberGroupOptions}
        shouldPrompt={shouldPrompt}
        valueItem={subscriberGroupValue}
        onChange={onChange}
        optionsParams={undefined}
        translation={translation} />
    </div>
  </>;
};
